/* Dr. Oldhaver – Abo-Umschalter im Warenkorb (siehe snippets/oh-cart-plan.liquid) */
(function () {
  if (window.__ohCartPlan) return; window.__ohCartPlan = true;
  async function refresh(json) {
    if (document.querySelector('[data-oh-cart-page]') || location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
    try {
      if (json && json.sections && window.eventBus) window.eventBus.emit('update:cart:drawer', json);
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart);
    } catch (e) { location.reload(); }
  }
  async function change(body) {
    var r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    return r.json();
  }
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-oh-cart-plan] button'); if (!btn) return;
    var wrap = btn.closest('[data-oh-cart-plan]'); var line = parseInt(wrap.dataset.line, 10); var qty = parseInt(wrap.dataset.qty, 10) || 1;
    var plan = btn.dataset.plan; btn.disabled = true; btn.classList.add('is-busy');
    try {
      var body = { line: line, quantity: qty, sections: 'cart-drawer' };
      body.selling_plan = plan ? parseInt(plan, 10) : null;
      var json = await change(body);
      var item = json.items && json.items[line - 1];
      var stillHasPlan = item && item.selling_plan_allocation;
      if (!plan && stillHasPlan) {
        /* Fallback: Plan ließ sich nicht direkt entfernen → Zeile neu anlegen ohne Plan */
        var variantId = item.variant_id;
        await change({ line: line, quantity: 0 });
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty }) });
        json = await fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) { return { sections: s }; });
      }
      await refresh(json);
    } catch (err) { console.error('Abo-Umschaltung fehlgeschlagen', err); btn.disabled = false; btn.classList.remove('is-busy'); }
  });
})();
